import(/* webpackMode: "eager", webpackExports: ["ThemeToggle"] */ "/vercel/path0/src/app/(providers)/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/i18n/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarUserMenuItem"] */ "/vercel/path0/src/modules/navbar/navbar-user-menu-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarUserMenu"] */ "/vercel/path0/src/modules/navbar/navbar-user-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWrapper"] */ "/vercel/path0/src/modules/navbar/navbar-wrapper.tsx");
